import { getAll } from "../utilites/querySelector";

// @ts-check
const groups = document.querySelectorAll( '[data-paged]' );

groups.forEach( group => {
    const navs = group.querySelectorAll( '[data-nav]' );
    const pages = group.querySelectorAll( '[data-index]' );

    const businessCheckbox = group.querySelector( '[name="use-delivery-address[]"]' );
    if ( businessCheckbox ) {
        setDeliveryDetails( businessCheckbox );
        businessCheckbox.addEventListener( 'input', () => setDeliveryDetails( businessCheckbox ) );
    }

    pages.forEach( page => {
        if ( page.dataset.index !== '1' )
            page.classList.add( 'inactive' );
    } );

    navs.forEach( nav => nav.addEventListener( 'click', navOnClick ) );

    setUpServiceDataSelects( group );
} );

function navOnClick( e ) {
    const button = e.currentTarget;
    const action = button.dataset.nav;
    const curPage = button.closest( '[data-index]' );

    switch ( action ) {
        case 'prev':
            const prevPage = curPage.previousElementSibling;
            if ( !prevPage ) return;
            curPage.classList.add( 'inactive' );
            prevPage.classList.remove( 'inactive' );
            break;

        case 'next':
            const isValid = validatePage( curPage );
            if ( !isValid ) return;
            const nextPage = curPage.nextElementSibling;
            if ( !nextPage ) return;
            curPage.classList.add( 'inactive' );
            nextPage.classList.remove( 'inactive' );
            break;

        case 'submit':
            return;

        default:
            console.warn( action + ' is not a valid nav property' );
    }
}

function validatePage( curPage ) {
    const inputs = getAll( '.wpcf7-validates-as-required', curPage );
    let valid = true;
    inputs.forEach( inp => {
        const value = inp.value;
        if ( !!value ) {
            inp.classList.remove( 'wpcf7-not-valid' );
        } else {
            valid = false;
            inp.classList.add( 'wpcf7-not-valid' );
        }
    } );
    return valid;
}


function setDeliveryDetails( inp ) {
    const details = inp.closest( 'form' ).querySelector( '[data-delivery-details]' );

    details.classList[inp.checked ? 'remove' : 'add']( 'inactive' );
}

function setUpServiceDataSelects( group ) {
    const item = group.querySelector( '[data-services]' );
    if ( !item ) return console.warn( 'There is no [data-services] attr for this paged form' );
    const services = JSON.parse( item.dataset.services );
    const select = item.querySelector( 'select[name=service]' );
    if ( !select ) return console.warn( 'There is no select field with the name \'service\' within this group' );

    let topLevelServices = [];
    let serviceGroups = [];

    Object.entries( services ).forEach( ( [service, subservices] ) => {

        if ( subservices.length === 0 ) {

            const option = document.createElement( 'option' );
            option.value = service;
            option.textContent = service;
            topLevelServices.push( option );

        } else {

            const serviceGroup = document.createElement( 'optgroup' );
            serviceGroup.label = service;

            subservices.forEach( subservice => {
                const option = document.createElement( 'option' );
                option.value = subservice;
                option.textContent = subservice;
                serviceGroup.appendChild( option );
                serviceGroups.push( serviceGroup );
            } );

        }
    } );

    select.innerHTML = '';
    serviceGroups.forEach( serviceGroup => select.appendChild( serviceGroup ) );
    topLevelServices.forEach( topLevelService => select.appendChild( topLevelService ) );
}